export default __webpack_public_path__ + "static/media/GRT.fc644031.svg";